/* eslint-disable import/no-anonymous-default-export */
import { UploadImg, Col, Form, Input, InputNumber, Row, } from "./../../../components/ui/ot";
import { useEffect } from "react";
import { useState } from "react";
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" || (!value) ? { ...all } : { ...all, [key]: value }, {})
}
export default (
    {
        propsForm = null,
        axiosMode = "post",
        formReloadCount = 0,
        onFormFinish = () => { },
        field
    }
) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [files, setFiles] = useState([])
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        setFiles(form.getFieldValue('file_data'))
        form.setFieldsValue(newFormValues)
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        let filess = form.getFieldValue('file_data');
        if (Array.isArray(filess))
            setFiles(filess)
    }
    const onFinish = (values) => {
        values = setParamsFilter(values)
        onFormFinish(values)
    }
    const onValuesChange = () => {
        let formValues = null
        formValues = form.getFieldsValue()

    }
    
    useEffect(() => {
        setDataInitialization()
    }, [])
    // useEffect(() => {
    //     let formValues = null
    //     formValues = form.getFieldsValue()
    //     setFormValuesOtherThings(formValues)
    //     return () => {
    //         setFiles([])
    //     }
    // }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    onFinishFailed={(e) => { console.log(e) }}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={[field?.name ?? '', "rwd_function_id"]}
                            >
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"標題"}
                                name={[field?.name ?? '', "rwd_function_name"]}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"連結"}
                                name={[field?.name ?? '', "rwd_function_url"]}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"連結排序"}
                                name={[field?.name ?? '', "index"]}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <InputNumber
                                    min={1}
                                />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item
                                name={[field?.name ?? '', "file_data"]}
                                initialValue={[]}
                            >
                                <UploadImg
                                    api={'/component/file'}
                                    defaultValue={form.getFieldValue([field?.name ?? '', 'file_data'].join('.'), files)}
                                    onImagesChange={(files) => {
                                        form.setFieldValue(
                                            [field?.name ?? '', 'file_data'].join('.'), [...files?.map(file => (
                                                {
                                                    file_id: file?.file_id
                                                }
                                            ))]
                                        )
                                        setFiles(files)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row >
    )
}